import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Loader2, AlertCircle, ArrowRight } from "lucide-react";
import { api } from "../api";
import { BrandMark } from "../components/Brand";

export default function QrLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!code) return;
    const cleaned = decodeURIComponent(String(code)).trim().toUpperCase();
    api.getArtworkByQr(cleaned)
      .then((art) => navigate(`/opera/${art.id}`, { replace: true }))
      .catch(() => setError("Codice QR non riconosciuto. Verifica che il QR appartenga a un'opera attiva."));
  }, [code, navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-6 page-enter">
        <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mb-4">
          <AlertCircle className="text-red-500" size={36} />
        </div>
        <h1 className="font-heading font-bold text-2xl text-ink text-center">Codice non valido</h1>
        <p className="text-ink-soft text-center mt-2 max-w-sm">{error}</p>
        <code className="mt-3 px-3 py-1 bg-white border border-border rounded-lg text-xs text-ink-soft font-mono">
          {String(code).toUpperCase()}
        </code>
        <Link
          to="/"
          data-testid="qr-landing-home"
          className="inline-flex items-center gap-2 bg-brand text-white px-5 py-3 rounded-full font-semibold mt-6 hover:bg-brand-hover transition"
        >
          Vai alla home <ArrowRight size={16} />
        </Link>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-6 page-enter" data-testid="qr-landing-loading">
      <div className="flex items-center gap-3 mb-6">
        <BrandMark size="lg" />
        <span className="font-heading font-bold text-2xl text-ink">QrTourist</span>
      </div>
      <Loader2 className="text-brand animate-spin mt-4" size={36} />
      <h1 className="font-heading font-bold text-2xl text-ink text-center mt-4">Stiamo aprendo l'opera…</h1>
      <p className="text-ink-soft text-center text-sm mt-1">Nessuna app da installare. Solo un attimo.</p>
    </div>
  );
}
